import { DisplayText, displayKey, displayText } from '@kikkz/shared/i18n/util';

/**
 * Formats a REAL match minute (e.g. from match results) for display.
 *
 * Value semantics:
 * - `null` / `undefined` → not yet available (`-`)
 * - `0` → no goal (`pg.common.noGoal`)
 * - `1`–`90` → minute (`{value}'`)
 * - `> 90` → stoppage time (`90'+`)
 *
 * NOT for the "minute of the first goal" dial ordinal — that index has its own
 * encoding (46 = 45'+); use `formatFirstGoalDial` from `./first-goal` instead.
 */
export function formatMatchMinute(value: number | null | undefined): DisplayText {
  if (value == null) return displayText('-');
  if (value === 0) return displayKey('pg.common.noGoal');
  if (value > 90) return displayText("90'+");
  return displayText(`${value}'`);
}
